import { getCountryPhoneCodes } from '@leanpay/utils'

import {
    currentMarket,
    IdentityCardType,
    isLocalEnvironment,
    isMarketSlo,
    isProdEnvironment,
    isStageEnvironment,
    isTestEnvironment,
    VerificationRoute,
} from 'library/constants'

export const countryPhoneCodes = getCountryPhoneCodes(currentMarket, isProdEnvironment)

export const daysInMonth = Array.from({ length: 31 }, (_, i) => `${i + 1}`).map((d) => {
    return { label: d, value: d }
})

export const getIdentityCardTypes = (translate: any) => [
    { label: translate('enum.identityCardType.PASSPORT'), value: IdentityCardType.PASSPORT },
    {
        label: translate('enum.identityCardType.PERSONAL_ID'),
        value: IdentityCardType.PERSONAL_ID,
    },
]

export const handleProgress = (route: string, setProgress: (progress: number) => void) => {
    switch (route.replace('/', '')) {
        case VerificationRoute.ChooseLogin:
            setProgress(10)
            break
        case VerificationRoute.RequestOtp:
            setProgress(20)
            break
        case VerificationRoute.Email:
            setProgress(20)
            break
        case VerificationRoute.Login:
            setProgress(40)
            break
        case VerificationRoute.InitVerification:
            setProgress(60)
            break
        case VerificationRoute.ConfirmVerification:
            setProgress(80)
            break
        case VerificationRoute.VerificationStatus:
            setProgress(100)
            break

        default:
            setProgress(100)
            break
    }
}

export const getResetVerificationPasswordLink = (): string => {
    if (isLocalEnvironment) {
        return 'http://localhost:4304/#/forgot-password'
    }

    if (isMarketSlo) {
        if (isTestEnvironment) return 'https://test-vendor.leanpay.si/#/forgot-password'
        if (isStageEnvironment) return 'https://stage-vendor.leanpay.si/#/forgot-password'
        if (isProdEnvironment) return 'https://vendor.leanpay.si/#/forgot-password'
    }

    return 'http://localhost:4304/#/forgot-password'
}
